import { apiRequest } from "../lib/apiClient";
import type { PurchaseOrderCreate, PurchaseOrderFromLowStockRequest, PurchaseOrderOut, ReceivePurchaseOrderRequest } from "./types";

export async function listPurchaseOrders(accessToken: string): Promise<PurchaseOrderOut[]> {
  return apiRequest<PurchaseOrderOut[]>("/purchase-orders", { accessToken });
}

export async function getPurchaseOrder(accessToken: string, poId: string): Promise<PurchaseOrderOut> {
  return apiRequest<PurchaseOrderOut>(`/purchase-orders/${poId}`, { accessToken });
}

export async function createPurchaseOrder(accessToken: string, body: PurchaseOrderCreate): Promise<PurchaseOrderOut> {
  return apiRequest<PurchaseOrderOut>("/purchase-orders", { method: "POST", accessToken, body });
}

/** `POST /purchase-orders/{id}/receive` — `{lines: [{line_id, quantity_received}]}`, a
 * DELTA received in THIS receipt, not a cumulative total (partial receiving supported —
 * call again later with the remaining quantity). Rejects (409) any line receipt that
 * would push cumulative `quantity_received` above `quantity_ordered`. */
export async function receivePurchaseOrder(
  accessToken: string,
  poId: string,
  body: ReceivePurchaseOrderRequest,
): Promise<PurchaseOrderOut> {
  return apiRequest<PurchaseOrderOut>(`/purchase-orders/${poId}/receive`, { method: "POST", accessToken, body });
}

/** `POST /purchase-orders/from-low-stock` — OWNER/BRANCH_MANAGER/ECOM_MGR (§14.12).
 * Re-derives low-stock items server-side (same query as `GET /reports/low-stock`),
 * targets 2x each item's `low_stock_threshold`, and creates the PO directly in `DRAFT`
 * status (the only route in this backend that does) using each item's last-known received
 * unit cost. 422 if nothing currently qualifies. */
export async function createPurchaseOrderFromLowStock(
  accessToken: string,
  body: PurchaseOrderFromLowStockRequest,
): Promise<PurchaseOrderOut> {
  return apiRequest<PurchaseOrderOut>("/purchase-orders/from-low-stock", { method: "POST", accessToken, body });
}
